import React from "react"

import "./phoneNumberForm.scss"

function PhoneNumberForm({ phoneNumber, setPhoneNumber, agreed, setAgreed, inputRef }) {
    return (
        <div className="phone-number-container">
            <div className="phone-number-wrap">
                <div className="phone-number-wrap-header">
                    <div className="how-to">HOW TO</div>
                </div>
                <div className="phone-number-wrap-content">
                    <div className="title">
                        Masukkan nomor telepon kamu yang terdaftar di Gopay<span className="star">*</span>
                    </div>
                    <div>
                        <input
                            type="text"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            className="phone-input"
                            ref={inputRef}
                            inputMode="numeric"
                            pattern="[0-9]*"
                        />
                    </div>
                    {/* <div className="info-text">
                        ※ Kindly double check before you enter the phone number since the voucher code can be sent only once.
                    </div> */}
                    <div className="agreement-section" onClick={() => setAgreed(!agreed)}>
                        <div className="agreement-text">
                            Persetujuan untuk pengumpulan informasi pribadi<span className="star">*</span>
                        </div>
                        <label className="checkbox-container">
                            <input type="checkbox" checked={agreed} disabled />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                </div>
                <div>
                    <p>*pengumpulan informasi hanya dilakukan dengan tujuan untuk</p>
                    <p>pengiriman hadiah di event ini dan informasi akan di hancurkan setelah 3 bulan.</p>
                </div>
                {/* <div className="agreement-privacy">
                    <div className="sub-title">CONSENT TO THE COLLECTION AND PROCESSING OF PERSONAL INFORMATION</div>
                    <div className="agreement-privacy-text">
                        <p className="first-text">
                            THE COLLECTED PERSONAL INFORMATION WILL ONLY BE USED FOR THE PURPOSE OF SENDING OUT VOUCHER CODES TO THE WINNING
                            PARTICIPANTS, AND IT WILL BE DISCARDED AFTER 3 MONTHS.
                        </p>
                        <p>
                            1. PURPOSE OF COLLECTING PERSONAL INFORMATION: SENDING A VOUCHER CODE TO THE WINNERS. 2. PERSONAL INFORMATION COLLECTION
                            ITEMS: PHONE NUMBER. 3. PERSONAL INFORMATION RETENTION PERIOD: 3 MONTHS FROM THE DATE OF ENTRY.
                        </p>
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default PhoneNumberForm
